module.exports = __webpack_public_path__ + "static/img/logo-3.339cf6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-3.svg
// module id = C16e
// module chunks = 0